import { QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID } from '../constants/quickList.constants'

export const buildQuickListSearchPayload = ({
  pagination,
  status,
  searchText,
}) => ({
  ProductCustomListTypeId: QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID,
  PageNumber: pagination.currentPage,
  PageSize: pagination.pageSize,
  Status: status,
  Search: searchText || '',
})

export const extractQuickListItems = searchResponseData =>
  (searchResponseData || []).flatMap(
    group => group?.ListDetailProductCustomList || []
  )

export const extractQuickListTotal = searchResponseData => {
  const total = searchResponseData?.[0]?.TotalRegisters
  return typeof total === 'number' ? total : null
}

export const buildQuickListBatchUploadFormData = ({
  file,
  batchEntityId,
  tenantId,
  entityType,
}) => {
  const formData = new FormData()

  formData.append('FormFile', file)
  formData.append('TenantId', tenantId)
  formData.append('EntityType', entityType)
  formData.append('EntityId', batchEntityId)
  formData.append('InternalCode', batchEntityId)
  formData.append('MediaType', 'undefined')
  formData.append('MediaResourceId', 'undefined')
  formData.append('Order', 'null')
  formData.append('CompanyId', 'null')
  formData.append('DefaultProductPicture', 'false')
  formData.append('Date', new Date().toISOString())

  return formData
}

export const extractUploadedBatchFile = ({ uploadResponse, batchEntityId }) => {
  const firstData = uploadResponse?.Data?.find(
    data => data?.TableDoc?.EntityId === batchEntityId
  )
  const uploadResult = firstData?.TableDoc || {}

  return {
    fileUrl: firstData?.FileUrl,
    batchProcessId: uploadResult?.RowKey,
  }
}

export const extractBulkResult = batchSegments =>
  (batchSegments || []).reduce(
    (acc, segment) => {
      const segmentData = segment?.data || {}

      return {
        TotalRows: acc.TotalRows + (segmentData.TotalRows || 0),
        SuccessRows: acc.SuccessRows + (segmentData.SuccessRows || 0),
        FailedRows: acc.FailedRows + (segmentData.FailedRows || 0),
        Successes: [...acc.Successes, ...(segmentData.Successes || [])],
        Errors: [...acc.Errors, ...(segmentData.Errors || [])],
      }
    },
    { TotalRows: 0, SuccessRows: 0, FailedRows: 0, Successes: [], Errors: [] }
  )

export const downloadBlobFile = ({ blob, fileName }) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
